import { render } from "./ContentSearch.vue?vue&type=template&id=1cabe943"
import script from "./ContentSearch.vue?vue&type=script&lang=js"
export * from "./ContentSearch.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__